import React from "react";
import PropTypes from "prop-types";

export default function ArroClient(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-8.19465e-07 10.4162L2.80756e-06 12.5871L25.9699 12.5871L17.3637 21.465L18.8518 23L30 11.5L18.8518 9.21788e-07L17.3637 1.53505L25.9732 10.4162L-8.19465e-07 10.4162Z"
        fill={props.fill}
      />
    </svg>
  );
}
ArroClient.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};
ArroClient.defaultProps = {
  className: "",
  fill: "#063AC9",
  width: 30,
  height: 23,
  onClick: () => null
};
